"use client"

import { useState } from "react"
import data from "@emoji-mart/data"
import Picker from "@emoji-mart/react"
import {
  RibbonGroup,
  RibbonIconButton,
  RibbonToolbar,
} from "@/components/editor/ribbon/ribbon-primitives"
import { ShapesPicker } from "@/components/editor/ribbon/shapes-picker"
import { useRibbonActions } from "@/components/editor/ribbon/use-ribbon-actions"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

const R = "/ribbion_menu"

export function InsertToolbar({
  onOpenEquation,
}: {
  onOpenEquation?: () => void
}) {
  const actions = useRibbonActions()
  const [emojiOpen, setEmojiOpen] = useState(false)
  const [shapesOpen, setShapesOpen] = useState(false)

  return (
    <RibbonToolbar>
      <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/pageBreakIcon.svg`}
          hoverHint={`${R}/pageBreakHover.svg`}
          label="Page Break"
          onClick={actions.pageBreak}
        />
        <RibbonIconButton
          icon={`${R}/pictureIcon.svg`}
          hoverHint={`${R}/pictureHover.svg`}
          label="Picture"
          onClick={actions.picture}
        />
        <Popover open={shapesOpen} onOpenChange={setShapesOpen}>
          <PopoverTrigger asChild>
            <span>
              <RibbonIconButton
                icon={`${R}/shapesIcon.svg`}
                hoverHint={`${R}/shapesHover.svg`}
                label="Shapes"
              />
            </span>
          </PopoverTrigger>
          <PopoverContent className="w-auto border-0 p-0 shadow-lg" align="start">
            <ShapesPicker
              onSelect={(id) => {
                actions.shapes(id)
                setShapesOpen(false)
              }}
            />
          </PopoverContent>
        </Popover>
        <RibbonIconButton
          icon={`${R}/equationIcon.svg`}
          hoverHint={`${R}/equationHover.svg`}
          label="Equation"
          onClick={onOpenEquation}
        />
      </RibbonGroup>

      <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/codeIcon.svg`}
          hoverHint={`${R}/codeHover.svg`}
          label="Code Block"
          onClick={actions.codeBlock}
        />
        <Popover open={emojiOpen} onOpenChange={setEmojiOpen}>
          <PopoverTrigger asChild>
            <span>
              <RibbonIconButton
                icon={`${R}/emojisIcon.svg`}
                label="Emojis"
              />
            </span>
          </PopoverTrigger>
          <PopoverContent
            className="w-auto overflow-hidden rounded-lg border-0 p-0 shadow-lg"
            align="start"
          >
            <Picker
              data={data}
              theme="light"
              previewPosition="none"
              skinTonePosition="search"
              navPosition="bottom"
              perLine={7}
              emojiSize={18}
              emojiButtonSize={26}
              maxFrequentRows={1}
              onEmojiSelect={(emoji: {
                native?: string
                unified?: string
              }) => {
                // Prefer emoji-mart unified codepoints (Twemoji keys); fall back to native char
                const key = emoji.unified?.toLowerCase() || emoji.native
                if (key) {
                  actions.emoji(key)
                  setEmojiOpen(false)
                }
              }}
            />
          </PopoverContent>
        </Popover>
        <RibbonIconButton
          icon={`${R}/tabelIcon.svg`}
          hoverHint={`${R}/tabelHover.svg`}
          label="Table"
          onClick={actions.table}
        />
      </RibbonGroup>

      <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/videoIcon.svg`}
          hoverHint={`${R}/videoHover.svg`}
          label="Video"
          onClick={actions.video}
        />
        <RibbonIconButton
          icon={`${R}/linkIcon.svg`}
          hoverHint={`${R}/linkHover.svg`}
          label="Link"
          onClick={actions.link}
        />
        <RibbonIconButton
          icon={`${R}/bookmarkIcon.svg`}
          hoverHint={`${R}/bookmarkHover.svg`}
          label="Bookmark"
          onClick={actions.bookmark}
        />
        <RibbonIconButton
          icon={`${R}/commentIcon.svg`}
          hoverHint={`${R}/commentHover.svg`}
          label="Comment"
          onClick={actions.comment}
        />
      </RibbonGroup>

      <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/headerIcon.svg`}
          hoverHint={`${R}/headerHover.svg`}
          label="Header"
          onClick={actions.header}
        />
        <RibbonIconButton
          icon={`${R}/footerIcon.svg`}
          hoverHint={`${R}/footerHover.svg`}
          label="Footer"
          onClick={actions.footer}
        />
        <RibbonIconButton
          icon={`${R}/pageNumberIcon.svg`}
          hoverHint={`${R}/pageNumberHover.svg`}
          label="Page Number"
          onClick={actions.pageNumber}
        />
      </RibbonGroup>

      {/* <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/bulletListIcon.svg`}
          hoverHint={`${R}/bulletListHover.svg`}
          label="Bullet List"
          onClick={actions.bulletList}
        />
        <RibbonIconButton
          icon={`${R}/numberListIcon.svg`}
          hoverHint={`${R}/numberListHover.svg`}
          label="Number List"
          onClick={actions.numberList}
        />
        <RibbonIconButton
          icon={`${R}/alphaListIcon.svg`}
          hoverHint={`${R}/alphaListHover.svg`}
          label="Alpha List"
          onClick={actions.alphaList}
        />
      </RibbonGroup> */}

      <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/textBoxIcon.svg`}
          hoverHint={`${R}/textBoxHover.svg`}
          label="Text Box"
          onClick={actions.textBox}
        />
        <RibbonIconButton
          icon={`${R}/dateAndTimeIcon.svg`}
          hoverHint={`${R}/dateAndTimeHover.svg`}
          label="Date and Time"
          onClick={actions.dateAndTime}
        />
        <RibbonIconButton
          icon={`${R}/dropCapIcon.svg`}
          hoverHint={`${R}/dropCapHover.svg`}
          label="Drop Cap"
          onClick={actions.dropCap}
        />
      </RibbonGroup>
    </RibbonToolbar>
  )
}
